import gsap from 'gsap';

function Header() {
  var last_scroll_position = 0;
  var ticking = false;
  var elLogo = document.querySelector('#elementor_header .logo_samaniego');

  function on_scroll(position_scroll) {
    // console.log(`position_scroll`, position_scroll);
    if(position_scroll > 0) {
      gsap.to(elLogo, {autoAlpha: 0});
    } else {
      gsap.to(elLogo, {autoAlpha: 1});
    }
  }

  window.addEventListener('scroll', function(e) {
    last_scroll_position = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(function() {
        on_scroll(last_scroll_position);
        ticking = false;
      });
    }

    ticking = true;
  });
}

export default Header;